module.exports = __webpack_public_path__ + "img/1534150024.70c9372d.jpg";